var _defs, _polyline, _polyline2, _line, _line2, _polygon, _ellipse, _path, _polyline3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b3ddee;}.cls-1,.cls-2,.cls-3{stroke:#0090b9;}.cls-1,.cls-2{stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#fff;}.cls-3{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.88px;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "20.49 60.31 11.67 95.98 21.92 93.81 29.55 100.72 38.2 68.04"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "37.86 67.54 47.59 100.87 55.05 93.77 65.34 95.68 56.07 59.12"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.75,
    y1: 67.87,
    x2: 53.53,
    y2: 87.51
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.34,
    y1: 67.54,
    x2: 22.53,
    y2: 87.51
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "38.51 13.89 44.86 20.57 53.86 17.83 55.87 26.66 65.09 28.6 62.23 37.21 69.21 43.3 62.23 49.39 65.09 58.01 55.87 59.94 53.86 68.78 44.86 66.03 38.51 72.72 32.15 66.03 23.16 68.78 21.14 59.94 11.92 58.01 14.78 49.39 7.81 43.3 14.78 37.21 11.92 28.6 21.14 26.66 23.16 17.83 32.15 20.57 38.51 13.89"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 38.51,
    cy: 43.7,
    rx: 17.37,
    ry: 17.26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.51,57.73a14,14,0,1,1,14.14-14A14.11,14.11,0,0,1,38.51,57.73Z"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "32.26 44.67 35.91 49.23 45.96 37.37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature5);
export default __webpack_public_path__ + "static/media/feature5.c80ed30d8b93ee121b149b4eeab62801.svg";
export { ForwardRef as ReactComponent };